export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理后台',
  'menu.admin.sub-page': '二级管理页',
  // 首页
  'menu.admin.dashboard': '首页',
  // 用户管理
  'menu.admin.user-list': '用户列表',
  'menu.admin.kyc': 'KYC管理',
  'menu.admin.user-detail': '用户详情',
  'menu.admin.user-keys': 'API Key 管理',
  // VCC管理
  'menu.admin.vcc-products': '产品管理',
  'menu.admin.vcc-applications': '卡片申请',
  'menu.admin.vcc-cards': '卡片管理',
  // 钱包管理
  'menu.admin.wallet-records': '充提记录',
  'menu.admin.wallet-history': '历史记录',
  'menu.admin.withdraw-config': '提现设置',
  // 汇兑管理
  'menu.admin.swap-manage': '兑换管理',
  'menu.admin.swap-orders': '兑换订单',
  // 分销管理
  'menu.admin.commission': '佣金管理',
  // 系统管理
  'menu.admin.roles': '角色管理',
  'menu.admin.operation-logs': '操作日志',
  // 旧菜单（保留兼容）
  'menu.admin.user-manage': '用户管理',
  'menu.admin.role-manage': '角色权限',
  'menu.admin.kyc-manage': 'KYC管理',
  'menu.admin.card-manage': '卡片管理',
  'menu.admin.card-application': '卡片申请',
  'menu.admin.user-cards': '用户卡片',
  'menu.admin.commission-manage': '返佣管理',
  'menu.login': '登录',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.wallet': '充提管理',
  'menu.wallet.records': '充提记录',
  'menu.wallet.history': '历史记录',
  'menu.account': '个人页',
  'menu.account.center': '邀请中心',
  'menu.account.settings': '个人设置',
  'menu.account.card-center': '卡片中心',
  'menu.account.assets': '我的资产',
  'menu.account.my-cards': '卡片申请',
  'menu.account.user-cards': '我的卡片',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.account.lang': '语言',
  'menu.account.theme': '外观',
  'menu.account.theme.light': '浅色模式',
  'menu.account.theme.dark': '深色模式',
  'menu.account.theme.system': '跟随系统',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  // 用户中心 — 用户 / 团队 / 订单 / 消费记录 / 用户资产
  'menu.users-center': '用户中心',
  'menu.users-center.users': '用户管理',
  'menu.users-center.teams': '团队管理',
  // 订单 — 全平台 Stripe 订单 + 退款
  'menu.users-center.orders': '订单管理',
  'menu.users-center.ledger': '消费记录',
  'menu.users-center.assets': '用户资产',
  // 模型接入 — 外部服务商 / 可调用模型 / 计费
  'menu.resources': '模型接入',
  'menu.resources.providers': '服务商管理',
  'menu.resources.route-models': '模型展示与调度',
  'menu.resources.routes': '任务路由',
  'menu.resources.pricing': '定价与成本',
  // 兼容 key:仅供 redirect 兜底
  'menu.resources.catalog': '模型管理',
  'menu.resources.models': '模型管理',
  'menu.resources.llm-routes': 'LLM 任务路由',
  'menu.resources.image-routes': '图像任务路由',
  // 创作配置 — AI 创作要素的全局配置
  'menu.studio': '创作配置',
  'menu.studio.prompts': '提示词模板',
  'menu.studio.skills': 'Skill 库',
  'menu.studio.skill-market': 'Skill 广场',
  // 内容运营 — Genvas 广场审核 + 运营触达 + 数据看板
  'menu.content': '内容运营',
  'menu.content.publications': '广场作品',
  'menu.content.reports': '举报池',
  'menu.content.popups': '运营弹窗',
  'menu.content.analytics': '数据看板',
  // 运行监控 — 纯观测:任务 / 平台 / 访问 / 成本 / 告警
  'menu.monitor': '运行监控',
  'menu.monitor.system': '平台监控',
  'menu.monitor.tasks': '任务监控',
  'menu.monitor.access': '访问日志',
  'menu.monitor.costs': '成本记录',
  'menu.monitor.alerts': '告警推送',
  // 系统设置 — 平台级运行配置 + 主动广播
  'menu.settings': '系统设置',
  'menu.settings.system': '系统设置',
  'menu.settings.announcements': '系统公告',
  // AI 单图生成
  'menu.image': 'AI 生图',
  'menu.image.generate': '单图生成',
  // AI 项目导演平台
  'menu.drama': '项目导演',
  'menu.drama.projects': '项目制作',
  'menu.drama.prompt-templates': '提示词模板',
};
